import _ from 'lodash'
import { GetAvailableBedCapacity, SearchTree, ValidateBedCapacity, ValidateCharacters } from "../../../constants/ProConstants";

const RoomValidator = ({model}, treeData)=>{ 

    let errors = {};
    
    if (_.isEmpty(model.location)) {           
        errors.location = "Please choose location.";
    }
    if (_.isEmpty(model.building)) {              
            errors.building = "Please choose building.";
    }
    if (_.isEmpty(model.name)) {               
            errors.name = "Room name is required.";
    }
    if (!_.isEmpty(model.name) && model.name.length > 120) {              
        errors.name = "Max 120 characters allowed";
    } 
    if(_.get(model.building, "name") && _.get(model.parentType, "code") && treeData){
        const availableCapacity = GetAvailableBedCapacity(treeData, (_.isEqual(model.parentType.code, "BUILDING") || _.isNull(model.parent))?model.building.key : model.parent.key, model.key)
        const error = ValidateBedCapacity(availableCapacity, model.bedCapacity);
        if(!_.isEmpty(error)){
            errors.bedCapacity = error;
        }
    }
    if (!_.isEmpty(model.name) && !ValidateCharacters(model.name)) {              
        errors.name = "Invalid Characters";
    } 
    if(_.get(model.parentType, "code") && !_.isEqual(model.parentType.code, "BUILDING"))
    {
        if(_.isNull(model.parent)){
            errors.parent = `Please choose ${model.parentType.name}`;
        }
    }
    if(_.get(model.building, "name") && _.get(model.parentType, "code") && treeData)  {  
        var parentKey = (_.isEqual(model.parentType.code, "BUILDING") || _.isEmpty(model.parent))?model.building.key : model.parent.key 
        var element = SearchTree(SearchTree(treeData, "key", parentKey ), "label", `${model.name}`);  
        if(!_.isNull(element) && element.key !== model.key && _.isEqual(element.parentId, parentKey))
            errors.name =  "Room name already exists!";
    }
        
    return errors;

}

export default RoomValidator;